import React, {useState} from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import {IconButton} from "@mui/material";
import {AddRounded, RemoveRounded} from "@mui/icons-material";
import {styled} from "@mui/material/styles";

import Badge from "components/Badge";

import {grey25, greyishBlue100, greyishBlue600} from "assets/jss/main";

const Container = styled('div')({
    backgroundColor: '#FFF',
    border: `1px solid ${greyishBlue100}`,
    borderRadius: '8px',
    overflow: 'hidden',
});

const Header = styled('div', {shouldForwardProp: prop => prop !== 'collapsed'})(({collapsed}) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '32px',
    padding: '16px',
    backgroundColor: grey25,
    borderBottom: collapsed ? 'none' : `1px solid ${greyishBlue100}`,
}));

const Title = styled('span')({
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: 'normal',
    color: greyishBlue600,
});

const ToggleButton = styled(IconButton)({
    color: greyishBlue600,
    padding: 0,
    '& svg': {
        fontSize: '20px',
    },
});

const Body = styled('div')({
    padding: '16px',
});

const Footer = styled('div')({
    padding: '16px',
    backgroundColor: grey25,
    borderTop: `1px solid ${greyishBlue100}`,
});

const FilterBlock = ({titleId = 'retailer.product.list.filter.title', activeFilterCount = 0, children, footer, alreadyOpen = false}) => {
    const [collapsed, setCollapsed] = useState(!alreadyOpen);

    return (
        <Container>
            <Header collapsed={collapsed}>
                <Title>
                    <FormattedMessage id={titleId}/>
                    {activeFilterCount > 0 && (
                        <Badge color="default" size="small" rounded>
                            {activeFilterCount}
                        </Badge>
                    )}
                </Title>
                <ToggleButton onClick={() => setCollapsed(!collapsed)} size="large">
                    {collapsed ? <AddRounded/> : <RemoveRounded/>}
                </ToggleButton>
            </Header>
            <div hidden={collapsed}>
                <Body>
                    {children}
                </Body>
            </div>
            {footer && (
                <Footer hidden={collapsed}>
                    {footer}
                </Footer>
            )}
        </Container>
    );
};

FilterBlock.propTypes = {
    titleId: PropTypes.string,
    activeFilterCount: PropTypes.number,
    children: PropTypes.node,
    footer: PropTypes.node,
};

export default FilterBlock;
